<div class="content-heading">
  <div class="header-container">
    <h3>Detalle de Línea de Transporte</h3>
    <small>Gestión de información fiscal y operativa del transportista</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default">
    <div class="card-body">
      <form #Form="ngForm" (ngSubmit)="formSubmit()">
        
        <div class="row">
          <div class="col-md-2">
            <aph-custom-text 
              label="ID" 
              [(ngModel)]="line.TransportLineId" 
              name="TransportLineId" 
              [disabled]="true"
              style="border:none;">
            </aph-custom-text>
          </div>

          <div class="col-md-5">
            <aph-custom-text 
              label="Transportista" 
              placeholder="Nombre comercial" 
              [(ngModel)]="line.LineName" 
              name="LineName" 
              [required]="true" 
              [maxLength]="30"
              style="border:none;">
            </aph-custom-text>
          </div>

          <div class="col-md-5">
            <aph-custom-text 
              label="RFC" 
              placeholder="Registro Federal de Contribuyentes" 
              [(ngModel)]="line.TransportNIT" 
              name="TransportNIT" 
              [required]="true" 
              [maxLength]="13"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6">
            <aph-custom-text 
              label="Razón Social" 
              placeholder="Nombre legal completo" 
              [(ngModel)]="line.FiscalName" 
              name="FiscalName" 
              [required]="true" 
              [maxLength]="100"
              style="border:none;">
            </aph-custom-text>
          </div>

          <div class="col-md-6">
            <aph-custom-text 
              label="Domicilio Fiscal" 
              placeholder="Calle, número, colonia, CP" 
              [(ngModel)]="line.TransportAddress" 
              name="TransportAddress" 
              [required]="true" 
              [maxLength]="150"
              style="border:none;">
            </aph-custom-text>
          </div>
        </div>

        <hr class="mt-4">

        <div class="row mt-3">
          <div class="col-12 d-flex">
            <aph-custom-buttons 
              preset="save" 
              label="Guardar" 
              type="submit" 
              [disabled]="!Form.valid"
              class="mr-2">
            </aph-custom-buttons>

            <aph-custom-buttons 
              preset="exit" 
              label="Salir" 
              (btnClick)="btnCancelOnClick()">
            </aph-custom-buttons>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>